import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { QUALITY_CHECKLIST_API } from "../apiRoutes";

interface UseGetQualityChecklistByIdProps {
  id: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getQualityChecklistById = async (id: string) => {
  return await axiosAuth.get(`${QUALITY_CHECKLIST_API}/${id}`);
};

const useGetQualityChecklistById = ({
  id,
  queryParams,
}: UseGetQualityChecklistByIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["quality-checklist", id],
    queryFn: () => getQualityChecklistById(id),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetQualityChecklistById;
